export const moduleName = 'mainhome';
